import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { Box, Button, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Spinner } from "../../components/Loading/Spinner";
import { useSuperAdminUserSuscription } from "../../context/SuperAdmin/UserSuscriptionContext";
import SingleUserDescription from "../../components/Table/Users/Suscriptions/SingleUserDescription";
import { UserSuscriptTable } from "../../components/Table/Users/Suscriptions/UserSuscriptTable";
import DeleteSuscrModal from "../../components/Table/Users/Suscriptions/DeleteSuscrModal";

const UserSuscriptionPage = () => {
  const {
    isLoading,
    user,
    suscriptions,
    assignToDeleteSuscr,
    isDeleting,
    toDeleteSuscr,
    handleDelete,
  } = useSuperAdminUserSuscription();

  const navigate = useNavigate();
  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
        color: "#005559",
      }}
    >
      {/* Boton para volver */}
      <Grid item>
        <Button sx={{ color: "#336B87" }} onClick={() => navigate(-1)}>
          <ArrowBackOutlinedIcon />
          Volver
        </Button>
      </Grid>

      {isLoading ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Título */}
          <Grid item>
            <Typography
              variant={"h4"}
              sx={{ color: "#005559", fontSize: "30px" }}
            >
              <b>Usuario</b> | {user.nombres} {user.apellidos}
            </Typography>
          </Grid>

          {/* Características del usuario */}
          <Grid item>
            <SingleUserDescription />
          </Grid>

          {/* Linea divisoria */}
          <Grid item>
            <Box
              sx={{ height: "1px", width: 1, border: "1px solid #005559" }}
            ></Box>
          </Grid>

          {/* Subtítulo */}
          <Grid item>
            <Typography variant={"h5"}>
              <b>Suscripciones relacionadas</b>
            </Typography>
          </Grid>

          {/* Tabla de suscripciones */}
          <Grid item>
            <UserSuscriptTable
              suscripciones={suscriptions}
              assignToDeleteSuscr={assignToDeleteSuscr}
            />
          </Grid>

          {/* Modal para borrar suscripción de un plan */}
          <Grid item>
            <DeleteSuscrModal
              isDeleting={isDeleting}
              handleDelete={handleDelete}
              toDeleteSuscr={toDeleteSuscr}
              assignToDeleteSuscr={assignToDeleteSuscr}
              title="¿Quieres desaciar este usuario de la suscripción?"
              subtitle="Perderá sus créditos relacionados a esta"
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default UserSuscriptionPage;
